module.exports = __webpack_public_path__ + "static/media/Dual_Reflect_6210.20f30701.jpg";